import { render, staticRenderFns } from "./SoftwareDetailsBloc.vue?vue&type=template&id=94844290&"
import script from "./SoftwareDetailsBloc.vue?vue&type=script&lang=js&"
export * from "./SoftwareDetailsBloc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports